<app-toast></app-toast>

<div class="grid grid-cols-2 h-screen w-full mobile:flex">

    <div class="bg-primary-800 flex flex-col gap-5 mobile:hidden">
        <div class="flex self-center mt-[15%] mx-5">
            <div class="text-white max-w-[550px]">
                <h1 class="text-[38px] font-bold">{{ 'auth.welcome_to' | transloco }}</h1>
                <pre class="text-[16px] leading-6 whitespace-pre-line">{{ 'auth.platform_desc' | transloco }}</pre>

                <div class="flex items-center rounded-md w-[50px] h-1 gap-1 mt-5">
                    <div class="bg-white rounded-full h-1 w-3/4"></div>

                    <div class="flex items-center gap-1">
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-grow flex justify-end items-end">
            <img src="assets/images/signup-page/dashboard-example.png"
                alt="{{ 'auth.dashboard_example_image' | transloco}}"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
    </div>

    <div class="bg-white p-4 z-40 px-[5%] flex flex-col h-full mobile:px-7 mobile:w-screen">
        <div class="flex w-full items-center justify-between mobile:justify-center mobile:mt-10">
            <app-logo></app-logo>

            <div class="flex gap-2 flex-wrap items-center justify-center mobile:hidden">
                <p>{{ 'auth.remembered_password' | transloco}}</p>
                <div class="w-20 h-[40px]">
                    <app-secondary-button buttonText="{{ 'auth.sign_in' | transloco}}" [isDisabled]="false"
                        (buttonClick)="signInButtonClick()">
                    </app-secondary-button>
                </div>
            </div>
        </div>

        <div class="flex-grow flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-5">
                <h1 class="text-5xl font-bold mobile:text-xl mobile:mt-[10vh]">{{ 'auth.reset_password' | transloco}}
                </h1>
                <p class="mt-1 mobile:text-base">{{ 'auth.enter_email' | transloco}}</p>

                <div class="mt-[10%]">
                    <app-labeled-input labelText="{{ 'auth.email_address' | transloco}}"
                        [iconSrc]="'assets/icons/sms.svg'" iconAltText="'{{ 'auth.sms_icon' | transloco}}'"
                        [inputId]="'email'" [inputType]="'email'" [(inputValue)]="emailInput"
                        [errorMessage]="emailInputError" autocomplete="email" [isDisabled]="resetToken ? true : false"></app-labeled-input>
                </div>

                <div class="mt-[10%]" *ngIf="resetToken">
                    <app-labeled-input labelText="{{ 'auth.set_new_password' | transloco}}"
                        [inputId]="'password'" [inputType]="'password'" [(inputValue)]="passwordInput"
                        [errorMessage]="passwordInputError"
                        placeholder="{{ 'auth.enter_your_new_password' | transloco}}"
                        boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" autocomplete="new-password"></app-labeled-input>
                </div>
                <p *ngIf="isSend" class="mt-6 text-primary">{{ 'auth.link_has_been_send' | transloco}}</p>

                <div class="mt-12">
                    <app-primary-button *ngIf="!resetToken" buttonText="{{ 'auth.send_instructions' | transloco}}" [isDisabled]="isSend"
                        (buttonClick)="sendInstructionsClick()">
                    </app-primary-button>

                    <app-primary-button *ngIf="resetToken" buttonText="{{ 'auth.reset_password' | transloco}}" [isDisabled]="isReset"
                        (buttonClick)="resetPasswordClick()">
                    </app-primary-button>
                </div>
            </div>
            <div class="hidden mt-6 mobile:block">
                <p class="font-normal">{{ 'auth.remembered_password' | transloco}} <a routerLink="/signup"
                        class="text-primary hover:underline">{{ 'auth.sign_in' | transloco}}</a></p>
            </div>

        </div>
    </div>


</div>